import React, { useCallback, useState } from 'react';
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper,
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';

import ReferralList from './charts/ReferralList';
import ReferralListByUser from './charts/ReferralListByUser';
import AnalyticsDateFilter from './components/AnalyticsDateFilter';

dayjs.extend(quarterOfYear);

export default function ViewAnalytics() {
  const [appliedRange, setAppliedRange] = useState({
    start: dayjs().startOf('quarter'),
    end: dayjs().endOf('quarter'),
  });
  const [activeTab, setActiveTab] = useState(0);

  const charts = [
    { label: 'Sent Referrals', component: ReferralList, type: 'sent' },
    { label: 'Received Referrals', component: ReferralList, type: 'received' },
    { label: 'Sent Referrals by Users', component: ReferralListByUser, type: 'sent' },
    { label: 'Accepted Referrals by Users', component: ReferralListByUser, type: 'accepted' },
    { label: 'Declined Referrals by Users', component: ReferralListByUser, type: 'declined' },
  ];

  const handleApplyRange = useCallback(({ start, end }) => {
    setAppliedRange({ start, end });
  }, []);

  return (
    <Box sx={{ width: '100%', p: 3 }}>
      <Typography variant="h2" gutterBottom>
        Referral Analytics
      </Typography>

      {/* Date Filter */}
      <Box sx={{ mt: 3, mb: 3 }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <AnalyticsDateFilter onApply={handleApplyRange} />
        </LocalizationProvider>
      </Box>

      {/* Tabs */}
      <Paper elevation={0} sx={{ borderRadius: '12px', overflow: 'hidden' }}>
        <Box sx={{ bgcolor: '#f5f5f5', px: 1, pt: 1, mb: '-9px' }}>
          <Tabs
            value={activeTab}
            onChange={(e, newVal) => setActiveTab(newVal)}
            variant="scrollable"
            scrollButtons="auto"
            TabIndicatorProps={{ style: { display: 'none' } }}
            sx={{
              borderBottom: '1px solid #ccc',
              '& .MuiTab-root': {
                textTransform: 'none',
                minHeight: '36px',
                fontWeight: 500,
                border: '1px solid transparent',
                borderBottom: 'none',
                borderRadius: '6px 6px 0 0',
                mx: 0.5,
                px: 2,
                py: 1,
                backgroundColor: 'transparent',
                color: '#555',
              },
              '& .Mui-selected': {
                backgroundColor: '#fff',
                color: '#000',
                border: '1px solid #ccc',
                borderBottom: 'none',
                zIndex: 1,
              },
            }}
          >
            {charts.map((chart, index) => (
              <Tab key={index} label={chart.label} />
            ))}
          </Tabs>
        </Box>

        {/* Chart Panel */}
        <Box sx={{ p: 2, bgcolor: 'white', border: '1px solid #ccc', minHeight: 600 }}>
          {charts.map((chart, index) => {
            const Component = chart.component;
            return activeTab === index ? (
              <Component
                key={index}
                startDate={appliedRange.start}
                endDate={appliedRange.end}
                type={chart.type}
              />
            ) : null;
          })}
        </Box>
      </Paper>
    </Box>
  );
}
